import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { DefaultProcessStepSchema, IndustrialProcessSchema } from "../types";
import { makeCreateInputSchema } from "../utils/zod-utils/makeCreateInputSchema";
import { makeUpdateInputSchema } from "../utils/zod-utils/makeUpdateInputSchema";

const c = initContract();

export const PredictedDefaultProcessStepSchema = z.object({
  industrialProcess: IndustrialProcessSchema,
  description: z.string().nullable(),
  preparationTimeFormula: z.string().nullable(),
  cycleTimeFormula: z.string().nullable(),
  machineHourlyPrice: z.number().int().nullable(),
  isComputedFromSurfaceTreatment: z.boolean(),
});

export const defaultProcessStepsContract = c.router({
  getPredicted: {
    method: "GET",
    path: "/default-process-steps/predicted",
    query: z.object({
      industrialProcess: IndustrialProcessSchema,
      description: z.string().optional(),
    }),
    responses: {
      200: z.object({ predictedDefaultProcessStep: PredictedDefaultProcessStepSchema.nullable() }),
    },
    summary:
      "Fetch the default process step values as if it had been predicted, from the company's machine or surface treatment settings matching the given industrial process and description",
  },

  create: {
    method: "POST",
    path: "/default-process-steps",
    body: makeCreateInputSchema(DefaultProcessStepSchema.omit({ companySettingsId: true })),
    responses: {
      200: DefaultProcessStepSchema,
      400: z.object({ message: z.string() }),
    },
  },

  update: {
    method: "PUT",
    path: "/default-process-steps/:id",
    body: makeUpdateInputSchema(DefaultProcessStepSchema.omit({ companySettingsId: true })),
    responses: {
      200: DefaultProcessStepSchema,
    },
  },

  delete: {
    method: "DELETE",
    path: "/default-process-steps/:id",
    body: z.object({}).optional(),
    responses: {
      200: z.object({ success: z.boolean() }),
    },
  },
});
